import api from './api';

const fetchImportLocation = async (uuid) => {
  try {
    const { data } = await api.get(`/integration-import-locations/${uuid}`);

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

const createImportLocation = async (integrationUuid, encodedCsvFile) => {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_BASE_URL}/integration-import-locations`,
      {
        data: {
          type: 'integration_import_locations',
          attributes: {
            integration_uuid: integrationUuid,
            encoded_csv_file: encodedCsvFile,
          },
        },
      },
    );

    return { data: data.data };
  } catch (e) {
    return { errors: e.response?.data?.errors };
  }
};

export default {
  fetchImportLocation,
  createImportLocation,
};
